import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import * as JSLZString from 'lz-string';
import { environment } from '../environments/environment'
//import {LZStringService} from 'ng-lz-string';
declare var pako: any;

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const isLiveURL: boolean = true;

var baseURL = {
    biziverse: (isLiveURL ? 'https://biziverse.com/' : 'http://localhost:36160/'),
    biziFiles: (isLiveURL ? 'https://files.biziverse.com/' : 'http://localhost:33245/')
}
// var baseURL = (isLiveURL ? 'https://biziverse.com/' : 'http://localhost:35669/');
var baseAPIEndpoint = baseURL.biziverse + (isLiveURL ? 'ERPAPI/' : '') + 'webservice.asmx/';
var baseAPIEndpointBiziFiles = baseURL.biziFiles + 'webservice.asmx/';

var endpoints = {
    sendChange: baseAPIEndpoint + 'sendChange',
    sendChangeForm: baseAPIEndpoint + 'sendChangeForm',
    getData: baseAPIEndpoint + 'getData',
    uploadFileForm: baseAPIEndpoint + 'UploadSFileForm',
    biziFiles: baseAPIEndpointBiziFiles + 'manage',
}


@Injectable({
    providedIn: 'root'
})
export class APIService {
    //private lz: LZStringService
    constructor(private http: HttpClient, private loadingPnl: NgxSpinnerService) {
        this.intitIDB();

        //onsuccess() - success event as its argument
        this.requestOpenDB.onsuccess = (evt) => {
            /*console.log(evt)*/
			const getRes = this.requestOpenDB.result;
            getRes.close();						 		   
        }

        //onerror() - what the error was if the request fails
        this.requestOpenDB.onerror = (event) => {
            console.log('Error', event)
			const getRes = this.requestOpenDB.result;
            getRes.close();													 		   
        }

        //onupgradeneeded() - onupgradeneeded is called when you change the db version
        this.requestOpenDB.onupgradeneeded = (event) => {
            debugger
            // Todo - dynamic table creation
            const db = this.requestOpenDB.result;
            this.createObjectStores(db);
			const getRes = this.requestOpenDB.result;
            getRes.close();
        }
       
    //    this.setIDB('H', this.hCook);
    }
    
    // hJson = '[{"Tbl":"H","NodeID":102314,"RI":102314,"RAID":1,"Cmp":"Deep Applications","Y":"Deep Applications","C":false,"S":true,"P":false,"N":false,"ISAA":false,"M":false,"F":false,"CI":0,"City":"Ahmedabad","SD":12,"CD":1,"Country":"India                                             ","Rcvb":0,"I":0,"G":0,"Tgt":0,"RcvRDT":null,"RcvTxt":"","RcvUID":0,"RN":"","PT":null,"D":null,"Inxn":"","U":0,"ADT":null,"Appt":"","AID":0,"RUID":92306,"Title":"Mr.","FNm":"Chintan","LNm":"patel","W":"7777948698","Name":"Chintan Patel","E":"patel.deep1@gmail.com","Account":"7777948698","L":0,"Scr":0,"Src":"","Req":"","SDT":null,"CUID":1,"ISA":false,"Pr":"","IsRemove":0,"CC":0,"R":null,"Sn":true,"O":null,"BankInfo":"[]","Fdbk":"","Cnts":"[]","CstrPbl":0,"CstrPblNotes":""},{"Tbl":"H","NodeID":102315,"RI":102315,"RAID":0,"Cmp":"Google","Y":"Google","C":true,"S":false,"P":false,"N":false,"ISAA":null,"M":false,"F":false,"CI":0,"City":"","SD":0,"CD":1,"Country":"India","Rcvb":53762,"I":0,"G":0,"Tgt":0,"RcvRDT":"2023-02-16T18:36:00","RcvTxt":"Gentle reminder for pmt of Rs. 53,762  due to Space-X.","RcvUID":20955,"RN":"","PT":null,"D":null,"Inxn":"","U":20955,"ADT":null,"Appt":"","AID":0,"RUID":92307,"Title":"Mr.","FNm":"Ranjan","LNm":"Anjaa","W":"9787987987","Name":"Ranjan Anjaa","E":"","Account":"","L":0,"Scr":0,"Src":"","Req":"","SDT":null,"CUID":20955,"ISA":false,"Pr":"","IsRemove":0,"CC":91,"R":null,"Sn":true,"O":null,"BankInfo":"","Fdbk":"","Cnts":"[]","CstrPbl":0,"CstrPblNotes":""},{"Tbl":"H","NodeID":102318,"RI":102318,"RAID":0,"Cmp":"Dell","Y":"Dell","C":false,"S":false,"P":true,"N":false,"ISAA":null,"M":false,"F":false,"CI":0,"City":"","SD":12,"CD":1,"Country":"India","Rcvb":0,"I":0,"G":0,"Tgt":0,"RcvRDT":null,"RcvTxt":"","RcvUID":0,"RN":"","PT":null,"D":null,"Inxn":"","U":20955,"ADT":null,"Appt":"","AID":0,"RUID":92310,"Title":"Mr.","FNm":"","LNm":"Gohil","W":"8798764654","Name":"Gohil","E":"","Account":"","L":5,"Scr":0,"Src":"","Req":"","SDT":null,"CUID":20955,"ISA":false,"Pr":"","IsRemove":0,"CC":91,"R":null,"Sn":true,"O":null,"BankInfo":"","Fdbk":"","Cnts":"[]","CstrPbl":0,"CstrPblNotes":""},{"Tbl":"H","NodeID":102319,"RI":102319,"RAID":0,"Cmp":"Hp","Y":"Hp","C":false,"S":false,"P":true,"N":false,"ISAA":null,"M":false,"F":false,"CI":0,"City":"","SD":13,"CD":1,"Country":"India","Rcvb":0,"I":0,"G":0,"Tgt":0,"RcvRDT":null,"RcvTxt":"","RcvUID":0,"RN":"","PT":null,"D":null,"Inxn":"","U":20955,"ADT":"2023-02-21T18:20:00","Appt":"Abc","AID":20955,"RUID":92311,"Title":"Mr.","FNm":"","LNm":"Gohil","W":"9794545646","Name":"Gohil","E":"","Account":"","L":3,"Scr":0,"Src":"","Req":"","SDT":null,"CUID":20955,"ISA":false,"Pr":"","IsRemove":0,"CC":91,"R":null,"Sn":true,"O":null,"BankInfo":"","Fdbk":"","Cnts":"[]","CstrPbl":0,"CstrPblNotes":""},{"Tbl":"H","NodeID":102334,"RI":102334,"RAID":0,"Cmp":"Dell","Y":"Dell","C":true,"S":false,"P":false,"N":false,"ISAA":null,"M":false,"F":false,"CI":0,"City":"","SD":0,"CD":1,"Country":"India","Rcvb":1076.32,"I":3,"G":25,"Tgt":0,"RcvRDT":"2023-02-16T18:36:00","RcvTxt":"Gentle reminder for pmt of Rs. 10,76,.32  due to Space-X.","RcvUID":20955,"RN":"","PT":null,"D":null,"Inxn":"","U":20955,"ADT":null,"Appt":"","AID":0,"RUID":92326,"Title":"Mr.","FNm":"","LNm":"Patel","W":"9875112312","Name":"Patel","E":"dellparl@gmail.com","Account":"","L":0,"Scr":0,"Src":"","Req":"","SDT":null,"CUID":20955,"ISA":false,"Pr":"","IsRemove":0,"CC":91,"R":null,"Sn":true,"O":null,"BankInfo":"","Fdbk":"","Cnts":"[]","CstrPbl":0,"CstrPblNotes":""},{"Tbl":"H","NodeID":102335,"RI":102335,"RAID":134,"Cmp":"Divyansu Solution","Y":"Divyansu Solution","C":true,"S":false,"P":false,"N":false,"ISAA":false,"M":false,"F":false,"CI":0,"City":"","SD":0,"CD":1,"Country":"India","Rcvb":147250,"I":0,"G":0,"Tgt":0,"RcvRDT":null,"RcvTxt":"","RcvUID":0,"RN":"","PT":null,"D":null,"Inxn":"","U":20955,"ADT":null,"Appt":"","AID":0,"RUID":92327,"Title":"Mr.","FNm":"Divyansu","LNm":"Maheshawri","W":"9428946030","Name":"Divyansu Maheshawri","E":"divyansu1318@gmail.com","Account":"9428946030","L":0,"Scr":0,"Src":"","Req":"","SDT":null,"CUID":20955,"ISA":false,"Pr":"","IsRemove":0,"CC":91,"R":null,"Sn":true,"O":null,"BankInfo":"","Fdbk":"","Cnts":"[]","CstrPbl":0,"CstrPblNotes":""}]'
    hJson = `[]`;

    hCook = JSON.parse(this.hJson);
     
    indxDB = window.indexedDB;
    
    indDBV = 15; // indxDBVer;   // 12;

    //Check IndexedDB is supported or not.
    intitIDB = () => {
        if (!this.indxDB) {
            console.log("Your browser doesn't support a stable version of IndexedDB.");
            return;
        }
    }

    //Create indexedDB database
    requestOpenDB = this.indxDB.open('BiziverseIDB', this.indDBV);

    // createObjectStores() - Common function to create required object stores
    createObjectStores(db: IDBDatabase) {
        if (!db.objectStoreNames.contains('H')) {
            db.createObjectStore('H', {
                keyPath: "NodeID",
            });
        }
        if (!db.objectStoreNames.contains('erp_inv')) {
            db.createObjectStore('erp_inv', {
                keyPath: "NodeID",
            });
        }
    }

    

    //fetchERPStockItems() - Fetch ERP Stock Items from server
    fetchERPStockItems(getType: string = '', callback: any) {
        let erpAgencyID = 0;
        let agnCookie = localStorage.getItem("M");
        let agenTable = agnCookie ? JSON.parse(agnCookie) : [];
        if (agenTable.length > 0) {
            erpAgencyID = agenTable[0]?.ERPAgencyID || 0;
        }
        let jarvis: any = localStorage.getItem("Jarvis");
        if (jarvis) {
            jarvis = JSON.parse(jarvis);
        } else {
            if(callback) callback(false);
            return;
        }

        if (!erpAgencyID || erpAgencyID <= 0) {
            console.error('No ERP Agency ID provided for inventory update');
            if(callback) callback(false);
            return;
        }

        let data = [{
            StatusID: 1,
            StoreID: 0,
            changeType: getType
        }];

        let myParams = [{
            myLastSyncDT: this.getCookie('MyLastSyncDT'),
            myUserID: jarvis[0].UserID,
            myToken: jarvis[0].WebToken,
            forAgencyID: jarvis[0].AgencyIDs,
            myAgencyIDs: jarvis[0].AgencyIDs,
            isWeb: true,
            ForERPAgencyID: erpAgencyID,
            actionType: 'get',
            moduleID: 5,
            ownActionType: 'getItems',
            ownAPIModuleID: 1,
            data: JSON.stringify(data)
        }];

        this.getData(myParams, (successData: any) => {
            if (successData.error == true) {
                console.error('Error fetching updated inventory:', successData.message);
                if(callback) callback(false);
            } else {
                if (successData.updatePackage) {
                    let responseData = JSON.parse(successData.updatePackage);
                    if (responseData.Table[0].ErrCode != -1) {
                        console.error('Error in inventory update:', responseData.Table[0].ErrMsg);
                        if(callback) callback(false);
                    } else {
                        let updatedItems = responseData.Table1;
                        if (getType === 'UPDTPKG') {
                            if (updatedItems && updatedItems.length > 0) {
                                let itemsToRemove = updatedItems.filter((item: any) => item.IsRemove);
                                // Update IndexedDB with changed items
                                this.updateIDBItem('erp_inv', updatedItems); 
                                console.log('IndexedDB updated.');

                                if (itemsToRemove.length > 0) {
                                    // Extract IDs for deletion
                                    let idsToRemove = itemsToRemove.map((item: any) => item.NodeID);
                                    this.deleteIDBItem('erp_inv', idsToRemove);
                                }
                            } else {
                                console.log('No updated inventory items received');
                            }
                        } else {
                            this.setIDB('erp_inv', updatedItems);
                            console.log('erp_inv saved to IndexedDB successfully');
                        }
                        if(callback) callback(updatedItems);
                    }
                } else {
                    if(callback) callback(false);
                }
            }
        }, (failData: any) => {
            console.error('Failed to fetch updated inventory items');
            if(callback) callback(false);
        });
    }

    // getIDB() - Get all table data from indexedDB 
    getIDB = (cName: string, callback: any) => {
        const reqBZDB = this.indxDB.open('BiziverseIDB', this.indDBV);
        let finalData: any = [];

        reqBZDB.onsuccess = function (event) {
            const getRes = reqBZDB.result;
            const txn = getRes.transaction(cName, "readwrite");
            const objectStore = txn.objectStore(cName);
            
            var allRecords = objectStore.getAll();
            allRecords.onsuccess = function () {
                finalData = allRecords.result;
            };

            allRecords.onerror = function () {
                finalData = [];
                //callback(finalData);
            }

            txn.oncomplete = () => {
                getRes.close();
                callback(finalData);
            };
        };

        reqBZDB.onerror = (event) => {
            console.log(reqBZDB.error)
            finalData = [];
            callback(finalData);
        }

        reqBZDB.onupgradeneeded = (event) => {
            this.createObjectStores(reqBZDB.result);
        }
    }

     //setIDB() - set hall table data in indexeDB when login
     setIDB(cName: string, fullList: any) {
        debugger
        const reqBZDB = this.indxDB.open('BiziverseIDB', this.indDBV);

        reqBZDB.onsuccess = () => {
            const setRes = reqBZDB.result;
            const tx = setRes.transaction(cName, 'readwrite');
            const strData = tx.objectStore(cName);
            
            for (var i in fullList) {
                const putDB = strData.put(fullList[i])
            }
			const getRes = reqBZDB.result;
			getRes.close();
        }

        reqBZDB.onerror = (event) => {
            console.log('Error', event)
			const getRes = reqBZDB.result;
			getRes.close();		   
        }

        reqBZDB.onupgradeneeded = (event) => {
            this.createObjectStores(reqBZDB.result);
        }
    }

    //updateIDBItem() - update or add specific items in indexedDB
    updateIDBItem(cName: string, items: any[]) {
        const reqBZDB = this.indxDB.open('BiziverseIDB', this.indDBV);

        reqBZDB.onsuccess = () => {
            const setRes = reqBZDB.result;
            const tx = setRes.transaction(cName, 'readwrite');
            const strData = tx.objectStore(cName);
            
            // Update or add each item using put (it will add if not exists, update if exists)
            for (var i in items) {
                const putDB = strData.put(items[i]);
            }
            
            const getRes = reqBZDB.result;
            getRes.close();
        }

        reqBZDB.onerror = (event) => {
            console.log('Error updating IDB item', event)
            const getRes = reqBZDB.result;
            getRes.close();
        }
    }

    //deleteIDBItem() - delete specific items from indexedDB by ID
    deleteIDBItem(cName: string, itemIDs: any[]) {
        const reqBZDB = this.indxDB.open('BiziverseIDB', this.indDBV);

        reqBZDB.onsuccess = () => {
            const setRes = reqBZDB.result;
            const tx = setRes.transaction(cName, 'readwrite');
            const strData = tx.objectStore(cName);
            
            // Delete each item by its ID
            for (var i in itemIDs) {
                const deleteDB = strData.delete(itemIDs[i]);
            }
            
            const getRes = reqBZDB.result;
            getRes.close();
        }

        reqBZDB.onerror = (event) => {
            console.log('Error deleting IDB item', event)
            const getRes = reqBZDB.result;
            getRes.close();
        }
    }

    //resetEverthing() - delete localstorage & indexedDB 
    resetEverthing() {
        var reqBZDB = this.indxDB.deleteDatabase('BiziverseIDB');
        window.localStorage.clear();
		reqBZDB.onsuccess = function () {
            debugger
            console.log("Deleted database successfully");
        };
        reqBZDB.onerror = function () {
            debugger
            console.log("Couldn't delete database");
        };
        reqBZDB.onblocked = function () {
            debugger
            console.log("Couldn't delete database due to the operation being blocked");
        };
        window.location.href = "https://biziverse.com/";  
    }

    //getCookie
    getCookie(cookieName: any) {
        // if(cookieName == "H"){
        //     let tblH: any = localStorage.getItem(cookieName);
        //     return this.lz.decompress(tblH);
        // }
        return localStorage.getItem(cookieName);
    }

    setCookie(cookieName: any, data: any) {
        // if(cookieName == "H"){
        //     localStorage.setItem(cookieName, this.lz.compress(data));
        // }  
        // else{
        //     localStorage.setItem(cookieName, data);
        // }
        localStorage.setItem(cookieName, data);
    }

    removeCookie(cookieName: any) { 
        localStorage.removeItem(cookieName);
    }

    fn_isLiveURL(){
        return isLiveURL;
    }

    getBiziFilesURL(){
        return baseURL.biziFiles;
    }
    //sendChange
    sendChange(mp: any, successDB: any, failDB: any) {
        mp[0].isWeb = this.apiCheckWeb();
        let body = JSON.stringify(mp);
        //let body = 'hello';
        let apiRes: any;
        let resObj: any;

        //Get data from sp
        this.loadingPnl.show();
        
        this.http.post(endpoints.sendChange, { myParams: body }, httpOptions).subscribe(data => {
            this.loadingPnl.hide();
            apiRes = data;
            var res = JSON.stringify(apiRes.d);
            resObj = JSON.parse(res);
            if (resObj.error == true) {
                alert(resObj.message);
                failDB(resObj);
                return;
            }
            else {
                successDB(resObj);
                return;
            }
        });
    }

    sendChangeForm(mp: any, successDB: any, failDB: any) {
        mp[0].isWeb = this.apiCheckWeb();
        
        // 1. Convert JSON to string and compress using deflateRaw
        let jsonString = JSON.stringify(mp);
        let compressed = pako.deflateRaw(jsonString);
        
        // 2. Convert to Base64
        let base64Payload = btoa(Array.from(new Uint8Array(compressed)).map(byte => String.fromCharCode(byte)).join(''));
        
        // 3. Create FormData
        let formData = new FormData();
        formData.append("myParams", base64Payload);
        
        let apiRes: any;
        let resObj: any;
        
        // 4. Make HTTP POST request
        this.loadingPnl.show();
        
        this.http.post(endpoints.sendChangeForm, formData).subscribe({
            next: (data) => {
                this.loadingPnl.hide();
                apiRes = data;
                var res = JSON.stringify(apiRes.d);
                resObj = JSON.parse(res);
                
                if (resObj.error == true) {
                    alert(resObj.message);
                    failDB(resObj);
                    return;
                } else {
                    successDB(resObj);
                    return;
                }
            },
            error: (error) => {
                this.loadingPnl.hide();
                
                if (error && error.error && error.error.Message) {
                    alert(error.error.Message);
                } else {
                    alert('Something went wrong while processing your request. Please contact Team Biziverse. E-001');
                    console.log('Error:', error);
                }
                
                if (failDB) {
                    failDB(error);
                }
            }
        });
    }

    uploadSFileForm(file: File, path: string, serverpath: string, successCB: any, failureCB: any) {
        try {
            // Create FormData
            let formData = new FormData();
            formData.append("file", file);
            formData.append("path", path);
            formData.append("serverpath", serverpath);
            
            // Make HTTP POST request with responseType: 'text' to handle XML
            this.loadingPnl.show();
            
            this.http.post(endpoints.uploadFileForm, formData, { responseType: 'text' }).subscribe({
                next: (xmlResponse: string) => {
                    this.loadingPnl.hide();
                    
                    // Parse XML response
                    const parser = new DOMParser();
                    const xmlDoc = parser.parseFromString(xmlResponse, "text/xml");
                    
                    // Extract error and message from XML
                    const errorNode = xmlDoc.getElementsByTagName("error")[0];
                    const messageNode = xmlDoc.getElementsByTagName("message")[0];
                    
                    const error = errorNode ? errorNode.textContent === "true" : false;
                    const message = messageNode ? messageNode.textContent : "";
                    
                    const resObj = {
                        error: error,
                        message: message
                    };
                    
                    if (resObj.error === true) {
                        alert(resObj.message);
                        if (failureCB) {
                            failureCB(resObj);
                        }
                        return;
                    } else {
                        if (successCB) {
                            successCB(resObj);
                        }
                        return;
                    }
                },
                error: (error) => {
                    this.loadingPnl.hide();
                    
                    if (error && error.error && error.error.Message) {
                        alert(error.error.Message);
                    } else {
                        alert('Something went wrong while uploading file. Please contact Team Biziverse.');
                        console.log('Error:', error);
                    }
                    
                    if (failureCB) {
                        failureCB(error);
                    }
                }
            });
            
        } catch (error: any) {
            this.loadingPnl.hide();
            alert('Upload error: ' + error.message);
            console.error('Upload error:', error);
            if (failureCB) {
                failureCB(error);
            }
        }
    }


    //getData
    getData(mp: any, successDB: any, failDB: any) {
        mp[0].isWeb = this.apiCheckWeb();
        let body = JSON.stringify(mp);
        //let body = 'hello';
        let apiRes: any;
        let resObj: any;
        //Get data from sp
        this.loadingPnl.show();
        this.http.post(endpoints.getData, { myParams: body }, httpOptions).subscribe(data => {            
            this.loadingPnl.hide();
            apiRes = data;
            var res = JSON.stringify(apiRes.d);
            resObj = JSON.parse(res);
            if (resObj.error == true) {
                alert(resObj.message);
                failDB(resObj);
                return resObj;
            }
            else {
                let tmpData: any = JSON.parse(resObj.updatePackage);
                if(tmpData.Table[0].ErrCode == '1000'){
                    alert(tmpData.Table[0].ErrMsg)
                    if(!isLiveURL){
                        // window.location.href = "https:\\biziverse.com";
                    }
                    else{
                        this.resetEverthing() 
                        //window.localStorage.clear();
                        // window.open("https:\\biziverse.com", "_self");
                        //window.location.href = "https://biziverse.com/";                  
                    }
                }
                else{
                    successDB(resObj);
                    return resObj;
                }
            }
        });
    }

    //Alert Region
    errorAlert(alert: any) {
        Swal.fire('Biziverse', alert, 'error')
    }

    successAlert(alert: any) {
        Swal.fire('Biziverse', alert, 'success')
    }

    simplaeAlert(alert: any) {
        Swal.fire(alert)
    }

    infoAlert(alert: any) {
        Swal.fire('Biziverse', alert, 'info')
    }

    // confirmAlert(alert: string, success: any, fail: any){
    //     Swal.fire({
    //         title: 'Biziverse',
    //         confirmButtonText: 'Ok',
    //         cancelButtonText: 'Cancel',
    //         showCancelButton: true,
    //         preConfirm: success()
    //       });
    // }

    swalConfirm(conirmText: any, successFun: any, failureFun: any = '') {
        Swal.fire({
            title: 'Biziverse',
            text: conirmText,
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                successFun();
            } else if (result.isDenied) {
                failureFun();            
            }
          })
    }

    //apiCheckWeb() - Check Jarvis  is Web Or APP
    apiCheckWeb() {
        var retVal = true;
        var jrvs = this.getCookie('Jarvis');
        if (jrvs) {
           let jarvisArray: Array<any> = JSON.parse(jrvs);
            if (jrvs.length > 0) {
                retVal = (jarvisArray[0].IsWeb != null  && jarvisArray[0].IsWeb != 'undefined') ? jarvisArray[0].IsWeb : true;
            }
        }
		return retVal;
	}

    //checkIsPremium() - Check Premium or Expired
    checkIsPremiumOrTrial(){
        let tblM: any = this.getCookie('M');
        if(tblM){
            tblM = JSON.parse(tblM);
            if(tblM.length > 0){
                let preTillDT: any =  new Date(tblM[0].PremiumTillDT);
                preTillDT = preTillDT.setHours(0, 0, 0, 0);
                preTillDT = new Date(preTillDT);

                let todayDT: any =  new Date();
                todayDT = todayDT.setHours(0, 0, 0, 0);
                todayDT = new Date(todayDT);
                
                if(tblM[0].SubscriptionTypeID == 3 && preTillDT >= todayDT){
                    return true;
                }
                else if(tblM[0].SubscriptionTypeID == 2 && preTillDT >= todayDT){
                    return true;
                }
                return false;
            }
            return false;
        }
        return false;
    }

    checkisIndianAgency() {
        let tblM: any = this.getCookie('M');
        if(tblM){
            tblM = JSON.parse(tblM);
            if(tblM.length > 0){
                if(tblM[0].CC == 91){
                   return true;
                }
                return false;
            }
            return false;
        }
        return false;
    }

    //checkBzvzEdition() - Check bzvz Editions
    checkBzvzEdition() {
        let tblM: any = this.getCookie('M');
        if(tblM){
            tblM = JSON.parse(tblM);
            if(tblM.length > 0){
                return tblM[0].EdnTID;
            }
            return 0;
        }
        return 0;
    }
    //checkFeatureAccess() - check all rigths
    checkFeatureAccess(page: string) {
        let jarvisArray: any;
        var jrvs = this.getCookie('Jarvis');
        if (jrvs) {
            jarvisArray = JSON.parse(jrvs); 
            }
        let tmpRights: any = [];
        tmpRights = localStorage.getItem('J');
        if (tmpRights) {
            tmpRights = JSON.parse(tmpRights);
            let ownRights = tmpRights.filter((o: any) => o.UserID == jarvisArray[0].UserID);
            let i = 0;
            if (ownRights.length > 0) {


                if (page == 'accounts') {
                    
                    return ownRights[i].Accts || ownRights[i].PropEntry || ownRights[i].AcctsVchrEntry ? true : false;
                }
                else if (page == 'Stock') {
                    return ownRights[i].Inv || ownRights[i].InvXns || ownRights[i].InvMstrs || ownRights[i].InvRpts || ownRights[i].InvCfg ? true : false;
                }
                else if (page == 'ProductionList') {
                    return ownRights[i].Prd || ownRights[i].PrdRpts || ownRights[i].PrdCfg ? true : false;
                }  
                else {
                    return false;
                }
            }
            else {
                return false;
            }

        }
        else {
            return false;
        }
        
    }

    //checkIsPremiumPaid() - check this agency is freemium or premium
    checkIsPremiumPaid() {
        let tblM: any = this.getCookie('M');
        if(tblM){
            tblM = JSON.parse(tblM);
            if(tblM.length > 0){
                let preTillDT: any =  new Date(tblM[0].PremiumTillDT);
                preTillDT = preTillDT.setHours(0, 0, 0, 0);
                preTillDT = new Date(preTillDT);

                let todayDT: any =  new Date();
                todayDT = todayDT.setHours(0, 0, 0, 0);
                todayDT = new Date(todayDT);
                
                if (tblM[0].SubscriptionTypeID == 3 && preTillDT >= todayDT) {
                    return true;                     
                }
                else {
                    return false;
                }
            }
            else{
                return false
            }
        } 
        else{
            return false
        }         
    }

    //setZipCookie - set value in zip and set cookie in localstorage
    setZipCookie(cookieName: any, data: any) {
        let compresseCookie = ''; 
        compresseCookie = JSLZString.compress(data);
        this.setCookie(cookieName, compresseCookie);
    }

    //setZipCookie - set value in zip and set cookie in localstorage
    getZipCookie(cookieName: any) {
        let cookieData: string | null = '';
        let respCookieData: string = '';

        cookieData = this.getCookie(cookieName);
        if(cookieData && cookieData != null && !cookieData.startsWith("[")){
            respCookieData = JSLZString.decompress(cookieData) || '';
        }
        return respCookieData;
    }

    uploadFile(mp: any, successDB: any, failDB: any) {
        if (!mp || mp.length === 0 || !mp[0].data || !mp[0].fileName) return successDB('');

        const allowedExtensions = ['pdf', 'jpg', 'jpeg', 'png', 'bmp', 'gif'];
        const extension = mp[0].fileName.split('.').pop()?.toLowerCase() || '';

        if (!allowedExtensions.includes(extension)) {
            this.errorAlert('Only PDF and Image files are allowed.');
            return failDB('Please select a valid file type');
        }

        const myParams = [{
            forAgencyID: mp[0].agencyID,
            actionType: 'uploadFile',
            data: JSON.stringify(mp)
        }];

        fetch(endpoints.biziFiles, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                myParams: JSON.stringify(myParams)
            })
        })
        .then(res => res.json())
        .then(result => {
            const data = typeof result.d === 'string' ? JSON.parse(result.d) : result.d;
            if (data && !data.error) {
                // Return only the filename in timestamp~^filename.format
                successDB(mp[0].fileName);
            } else {
                this.errorAlert('File upload failed: ' + (data?.message || ''));
                failDB(data?.message || 'Upload failed');
            }
        })
        .catch(error => {
            console.error('Upload error:', error);
            this.errorAlert('Error uploading file.');
            failDB(error);
        });
    }
}

export const isGalaxyFoldPhome: boolean = (window.innerWidth <= 300) ? true : false;

// myCurrency() - to find the currency code and symbol for logged in agency
export const myCurrency = () => {
    let currencyObj = { code: "INR", symbol: "₹" };

    try {
        const agencyData = JSON.parse(window.localStorage.getItem("M") || "[]");
        if (!agencyData?.length) return currencyObj;

        const countryList = JSON.parse(window.localStorage.getItem("Cfg_Ctry") || "[]");
        if (!countryList?.length) return currencyObj;

        const country = countryList.find((c: any) => c.CountryID == agencyData[0].CountryID);
        if (!country) return currencyObj;

        const currencyList = JSON.parse(window.localStorage.getItem("Cfg_Curr") || "[]");
        if (!currencyList?.length) return currencyObj;

        const currency = currencyList.find((c: any) => c.CurrencyID == country.CurrencyID);
        if (!currency) return currencyObj;

        currencyObj.code = currency.CurrencyCode;
        currencyObj.symbol = currency.CurrencySymbol

        return currencyObj
    } catch (e) {
        return currencyObj;
    }
};



